import { useTranslation } from "react-i18next"

import type { SupportedLanguageCode } from "@/models/i18n"
import {
  type FormatPersonNameParams,
  formatPersonName,
  formatPersonNameInitials,
} from "@/utils/person-name"

interface UseFormatPersonNameValue {
  formatPersonName: (params: Omit<FormatPersonNameParams, "locale">) => string
  formatPersonNameInitials: (
    params: Omit<FormatPersonNameParams, "locale">
  ) => string
}

export const useFormatPersonName = (): UseFormatPersonNameValue => {
  const { i18n } = useTranslation()

  const locale = i18n.language as SupportedLanguageCode

  const formatPersonNameForLanguage = (
    params: Omit<FormatPersonNameParams, "locale">
  ): string => {
    return formatPersonName({
      ...params,
      locale,
    })
  }

  const formatPersonNameInitialsForLanguage = (
    params: Omit<FormatPersonNameParams, "locale">
  ): string => {
    return formatPersonNameInitials({
      ...params,
      locale,
    })
  }

  return {
    formatPersonName: formatPersonNameForLanguage,
    formatPersonNameInitials: formatPersonNameInitialsForLanguage,
  }
}
